


const aboutSection = $('#about-section');
const aboutCard = aboutSection.find('.about-card');
const aboutImagesParent = aboutSection.find('.about-graph-parent');
const aboutCardTitles = aboutSection.find('.about-card-title');
const aboutCardTexts = aboutSection.find('.about-card-text');
const aboutCardProgress = aboutSection.find('.about-card-progress-status');
const aboutCardImages = aboutSection.find('.about-card-image');

aboutCardImages.each(function (i) {
  $(this).css('z-index', `${1000 - i}`);
});

const resetCardsForStart = () => {
  aboutCardTitles.each((i, el) => {
    $(el).css({ opacity: i === 0 ? 1 : 0, y: i === 0 ? 0 : '2.5vw' });
  });
  aboutCardTexts.each((i, el) => {
    $(el).css({ opacity: i === 0 ? 1 : 0, y: i === 0 ? 0 : '1.25vw' });
  });
};

const changeImages = (index) => {
  gsap.set(aboutCardImages, {display: (i) => i == index ? 'block' : 'none'})
};

const animateGraphCard = (graphIndex, duration) => {
  const cardCount = aboutCardTitles.length;
  const cardTL = gsap.timeline({ paused: true });
  const progressStart = (100 / cardCount) * graphIndex;
  const progressEnd = (100 / cardCount) * (graphIndex + 1);
  const prevIndex = (graphIndex - 1 + cardCount) % cardCount;
  const currentTitle = aboutCardTitles.eq(graphIndex);
  const prevTitle = aboutCardTitles.eq(prevIndex);
  const currentText = aboutCardTexts.eq(graphIndex);
  const prevText = aboutCardTexts.eq(prevIndex);

  const cardEase1 = CustomEase.create('cardEase1', '0.00, 0.00, 0.20, 1.00');
  const cardEase2 = CustomEase.create('cardEase2', '0.80, 0.00, 1.00, 1.00');

  cardTL.fromTo(
    aboutCardProgress,
    { width: `${progressStart}%` },
    { width: `${progressEnd}%`, duration: duration, ease: 'none' },
    0
  );

  cardTL.fromTo(
    prevTitle,
    { y: '0', opacity: 1 },
    { y: '-1.875vw', opacity: 0, duration: 0.667, ease: cardEase2},
    0
  );

  cardTL.fromTo(
    currentTitle,
    { y: '2.5vw', opacity: 0 },
    { y: 0, opacity: 1, duration: 0.5, ease: cardEase1 },
    0.5
  );

  cardTL.fromTo(
    prevText,
    { y: '0', opacity: 1 },
    { y: '-1.25vw', opacity: 0, duration: 0.667, ease: cardEase2 },
    0
  );

  cardTL.fromTo(
    currentText,
    { y: '1.25vw', opacity: 0 },
    { y: 0, opacity: 1, duration: 0.5, ease: cardEase1 },
    0.5
  );

  return cardTL;
};

const animateGraphLoop = (duration) => {
  const loopTL = gsap.timeline({ paused: true, repeat: -1 });
  const cardCount = aboutCardTitles.length;

  for (let i = 0; i < cardCount; i++) {
    loopTL.addLabel(`step${i}`, duration * i);

    loopTL.call(() => changeImages(i), null, `step${i}`);
    loopTL.add(animateGraphCard(i, duration).play(), `step${i}`);
  }

  return loopTL;
};

const addProgressController = (loopTL) => {
  const progressControllers = aboutSection.find('.about-card-progress-controller');
  progressControllers.each(function () {
    $(this).on('click', () => {
      const id = $(this).attr('id').replace('controller-', '');
      loopTL.seek(`step${id}`);
    });
  });
};

const animateAboutIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const aboutTL = gsap.timeline({
    paused: true,
  });

  aboutTL.add(
    animateSectionTopperIn({
      sectionParent: aboutSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  
  aboutTL.add(elementInAnimationYWOpacity(aboutCard, '36%', 0, 1, 0.63, 0.63).play(), 0);
  aboutTL.add(elementInAnimationYWOpacity(aboutImagesParent, '36%', 0, 1, 0.63, 0.63).play(), 0.3);

  return aboutTL;
}

const addLoopAnimation = () => {
  const duration = 8;
  const loopTL = animateGraphLoop(duration);

  resetCardsForStart();
  loopTL.play();
  addProgressController(loopTL);
}

const aboutTrigger = () => {
  const aboutTL = animateAboutIn();
  ScrollTrigger.create({
    trigger: aboutSection,
    start: 'top top+=110%',
    end: 'bottom bottom+=30%',
    once: true,
    /*onEnter: addLoopAnimation,*/
    onUpdate: (self) => {
      aboutTL.progress(self.progress);
    },
  });
}

addSectionObserver(aboutSection, aboutTrigger);
